<template>
  <v-tooltip :disabled="disabled" :bottom="bottom" :left="left" :right="right" :top="top">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :id="btnId"
        :color="color"
        :icon="isIcon"
        :text="isText"
        :small="small"
        :x-small="xSmall"
        :disabled="disabled"
        v-bind="attrs"
        v-on="on"
        @click="$emit('click')"
      >
        <v-icon v-if="icon" :class="{ 'mr-2': Boolean(text) }">
          {{ icon }}
        </v-icon>
        <span v-if="text">{{ text }}</span>
      </v-btn>
    </template>
    <span v-if="tooltip">{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'AnchorTooltipBtn',
  props: {
    btnId: String,
    tooltip: String,
    icon: String,
    text: String,
    color: String,
    small: Boolean,
    xSmall: Boolean,
    isIcon: Boolean,
    isText: Boolean,
    bottom: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean,
    disabled: Boolean,
  },
};
</script>
